export default __webpack_public_path__ + "static/media/bad-knees.3364f7fd.webp";